
export const SpsTimeInputExamples = {
    basic: {
        label: "Basic",
        description: `<p>Time Input</p>`,
        examples: {
            basic: {
                template: `
                    <form [formGroup]="form" id="timeInput">
                        <div class="row">
                            <div class="col-8">
                                <sps-time-input formControlName="timeInput"
                                id="basicTimeInput"></sps-time-input>
                            </div>
                        </div>
                    </form>
                `,
                class: `
                    class DemoComponent {
                        form: FormGroup;
                        constructor(fb: FormBuilder) {
                            this.form = fb.group({
                                timeInput: []
                            });
                        }
                    }
                `
            }
        }
    },
};
